export default "__VITE_ASSET__BGW$uHZ$__"